import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
  CardImg,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone";
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const AddAppVersion = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const versionTypeOptions = [
    { label: "ios", value: "ios" },
    { label: "android", value: "android" },
  ];
  const [versionType, setVersionType] = useState(versionTypeOptions[0].value);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState();
  const [link, setLink] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [forceUpdate, setForceUpdate] = useState(false);
  const [status, setStatus] = useState(statusOptions[0].value);
  const [version, setVersion] = useState();
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [navObj, setNavObj] = useState();
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      var versionType = props.location.state?.item?.item_type;
      var title = props.location.state?.item?.title;
      var description = props.location.state?.item?.description;
      var link = props.location.state?.item?.link;
      var forceUpdate = props.location.state?.item?.force_update;
      var imageUrl = props.location.state?.item?.icon;
      var status = props.location.state?.item?.item_status;
      var version = props.location.state?.item?.version;
      setVersionType(versionType);
      setTitle(title);
      setDescription(description);
      setLink(link);
      setForceUpdate(forceUpdate);
      setImageUrl(imageUrl);
      setStatus(status);
      setVersion(version);
    }
  }, []);

  const handleSubmit = () => {
    if (!title) {
      setErrorMessage("Please Enter Title");
      setErrorAlert(true);
      return;
    } else if (!link) {
      setErrorMessage("Please Enter Link");
      setErrorAlert(true);
      return;
    } else if (!description) {
      setErrorMessage("Please Enter description");
      setErrorAlert(true);
      return;
    } else if (selectedFiles.length < 1) {
      setErrorMessage("Please select image");
      setErrorAlert(true);
      return;
    }

    setLoader(true)

    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("item_type", versionType);
    formdata.append("path", "appversions/update");
    formdata.append("title", title);
    formdata.append("description", description);
    formdata.append("link", link);
    formdata.append("title", title);
    if (forceUpdate) {
      formdata.append("force_update", true);
    }
    formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    formdata.append("item_status", status);
    formdata.append("version", version ? version : 18);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    if (!title) {
      setErrorMessage("Please Enter Title");
      setErrorAlert(true);
      return;
    } else if (!link) {
      setErrorMessage("Please Enter Link");
      setErrorAlert(true);
      return;
    } else if (!description) {
      setErrorMessage("Please Enter description");
      setErrorAlert(true);
      return;
    } else if (!imageUrl) {
      if (selectedFiles.length < 1) {
        setErrorMessage("Please select image");
        setErrorAlert(true);
        return;
      }
    } else if (!version) {
      setErrorMessage("Please Enter Version");
      setErrorAlert(true);
      return;
    }
    setLoader(true)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    // myHeaders.append(
    //   "Cookie",
    //   "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    // );

    var formdata = new FormData();
    formdata.append("item_type", versionType);
    formdata.append("path", "appversions/update");
    formdata.append("title", title);
    formdata.append("description", description);
    formdata.append("link", link);
    formdata.append("title", title);
    if (forceUpdate) {
      formdata.append("force_update", true);
    }
    if (!imageUrl) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    formdata.append("item_status", status);
    formdata.append("version", version);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      mimeType: "multipart/form-data",
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/app-version");
        }}
        onConfirm={() => {
          props?.history.push("/app-version");
          setSuccesAlert(false);
          setLoader(false)
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props?.location?.state?.edit
          ? "App Version Updated"
          : " New App Version Added"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const validateFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        if (width !== 70 || height !== 70) {
          setErrorMessage("Height and Width must be 70x70px")
          setErrorAlert(true)
          return
       }else{
        handleAcceptedFiles(file)
       }
      };
    };
  }
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (
      path == "png" ||
      path == "PNG"
    ) {
      setSelectedFiles(files);
      setImageUrl("");
    } else {
      setErrorMessage("Please select a .png file");
      setErrorAlert(true);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add App Version" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Version Type</Label>
                              <Select
                                isSearchable={false}
                                onChange={(e) => {
                                  setVersionType(e.value);
                                }}
                                placeholder={versionType ? versionType : ""}
                                defaultValue={versionType}
                                options={versionTypeOptions}
                                maxMenuHeight={120}
                                menuPlacement="auto"
                                required
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                          <Col lg={2} md={2} sm={6} style={{ paddingTop: 38 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="visibility"
                                value={forceUpdate}
                                defaultChecked={
                                  propsData?.item?.force_update
                                    ? propsData?.item?.force_update
                                    : forceUpdate
                                }
                                onChange={() => {
                                  setForceUpdate(!forceUpdate);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="visibility"
                              >
                                Force Update
                              </label>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setTitle(e.target.value);
                                }}
                                defaultValue={title}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          {" "}
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Link</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setLink(e.target.value);
                                }}
                                defaultValue={link}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <textarea
                                cols={20}
                                rows={3}
                                type="text"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setDescription(e.target.value);
                                }}
                                defaultValue={description}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <Card>
                              <CardBody>
                                <Form>
                                  {imageUrl && (
                                    <Row>
                                      <Col md={1}>
                                        <CardImg
                                          className="img-fluid"
                                          src={imageUrl}
                                          style={{
                                            marginBottom: 15,
                                            width: "50px",
                                          }}
                                          alt=""
                                        />
                                      </Col>
                                      <Col
                                        md={2}
                                        style={{
                                          marginTop: "auto",
                                          marginBottom: "auto",
                                        }}
                                      >
                                        <div
                                          style={{ cursor: "pointer" }}
                                          className="px-3 text-danger"
                                          onClick={() => {
                                            setImageUrl("");
                                          }}
                                        >
                                          <FaRegTrashAlt />
                                          Move To Trash
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      validateFileSize(acceptedFiles)
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted"/>
                                          </div>
                                          <h4>
                                            Drop files here or click to upload.
                                          </h4>
                                          <p style={{ fontSize: 12, color: "red",    marginBottom: 0 }}>{`Image should be 70X70 in png`}</p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {selectedFiles.map((f, i) => {
                                      return (
                                        <Card
                                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                          key={i + "-file"}
                                        >
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                              </Col>
                                              <Col>
                                                <Link
                                                  to="#"
                                                  className="text-muted font-weight-bold"
                                                >
                                                  {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                  <strong>
                                                    {f.formattedSize}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                </Form>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Version</Label>
                              <input
                                type="number"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setVersion(e.target.value);
                                }}
                                defaultValue={version}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/app-version");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        color="success"
                        type="submit"
                      >
                         {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddAppVersion;
